<lib-input
  [value]="searchQuery()"
  [placeholder]="'reason_selector_treatment_plan_search' | translate"
  background="white"
  (valueChange)="onSearchQueryChange($event)"
>
  <svg-icon class="text-text-tertiary" key="px-24-search" leftIcon></svg-icon>
</lib-input>

<div
  class="-mr-[26px] mt-2 flex min-h-0 flex-grow gap-4 rounded-bl-[32px] rounded-br-[48px] border-b-2 border-r-2 border-background-white pr-6"
>
  <div class="relative flex min-h-0 w-[288px] flex-col overflow-y-auto rounded-[32px] bg-background-white p-4">
    @if (classifications().state === DataState.Loading) {
      <ng-lottie
        currentcolor
        class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 text-text-primary"
        [options]="lottieOptions"
      ></ng-lottie>
    } @else if (classifications().state === DataState.Fetched) {
      <lib-category-list class="h-full overflow-auto">
        @for (classification of classifications().data; track classification.classification) {
          <lib-category-list-element
            (click)="onClassificationClick(classification.classification)"
            [active]="selectedClassification()?.classification === classification.classification"
            [count]="classification.count"
          >
            {{ classification.classification }}
          </lib-category-list-element>
        }
      </lib-category-list>
    }
  </div>

  <div class="flex min-h-0 flex-1 flex-col gap-3 overflow-auto">
    @if (classifications().state === DataState.Loading) {
      <ng-lottie
        currentcolor
        class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 text-text-primary"
        [options]="lottieOptions"
      ></ng-lottie>
    } @else {
      @for (category of selectedClassification()?.categories; track category.name; let i = $index) {
        @if (i === 0 || category.name !== selectedClassification()?.categories?.[i - 1]?.name) {
          <div class="flex items-center gap-2">
            <div class="typo-h6-light-uppercase">
              {{ category.name }}
            </div>
            <svg-icon
              class="text-primary-blue"
              key="px-16-info"
              size="sm"
              [libUiTooltip]="categoryTooltip"
              tooltipPosition="bottom"
            ></svg-icon>
            <ng-template #categoryTooltip>
              <div class="typo-h5-book min-w-[18px]">
                {{ category.description }}
              </div>
            </ng-template>
          </div>
        }
        <div class="flex flex-col gap-2">
          @for (item of category.treatments; track item.dentalCode) {
            <div
              class="flex flex-col gap-2 rounded-2xl border-2 bg-background-card-lvl3 pb-4 pl-4 pr-3 pt-3"
              [ngClass]="isSelected(item) ? 'border-primary-blue' : 'border-background-white'"
            >
              <div class="flex items-center justify-between text-primary-blue">
                <div class="typo-h4-semibold">{{ item.dentalCode }}</div>

                <div class="flex items-center gap-1">
                  <button class="btn-icon-small ml-2" (click)="isSelected(item) ? deselectItem(item) : selectItem(item)">
                    <svg-icon
                      key="px-16-plus"
                      size="sm"
                      class="transition-transform"
                      [ngClass]="{
                        'rotate-[135deg]': isSelected(item)
                      }"
                    />
                  </button>
                </div>
              </div>
              <div class="typo-h4-medium flex items-center justify-between pr-1.5 text-text-primary">
                <span>{{ item.description }}</span>

                <svg-icon
                  class="mt-1 shrink-0 text-text-light"
                  key="px-16-info"
                  size="sm"
                  [libUiTooltip]="treatmentTooltip"
                  tooltipPosition="bottom"
                />
                <ng-template #treatmentTooltip>
                  <div class="typo-h5-book min-w-[18px]">{{ item.longDescription }}</div>
                </ng-template>
              </div>
            </div>
          }
        </div>
      }
    }
  </div>
</div>
